import axios from "axios";

const API_BASE_URL =
  import.meta.env.VITE_API_URL || "http://localhost:8000/api/v1";

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 300000,
  withCredentials: true, // Enable sending cookies in cross-origin requests
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle token expiration
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Don't redirect if the error is from an auth endpoint (login/register)
    const isAuthEndpoint = error.config?.url?.includes('/auth/login') || 
                          error.config?.url?.includes('/auth/register');
    
    if (error.response?.status === 401 && !isAuthEndpoint) {
      // Clear storage and redirect to login
      localStorage.removeItem("token");
      document.cookie = 'authToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

// Helper functions for API calls
export const apiUtils = {
  // Backend API calls
  backend: {
    get: (url: string, config?: any) => api.get(url, config),
    post: (url: string, data?: any, config?: any) =>
      api.post(url, data, config),
    put: (url: string, data?: any, config?: any) => api.put(url, data, config),
    delete: (url: string, config?: any) => api.delete(url, config),
  },
};

// User Preferences API
export const userPreferencesApi = {
  // Get user preferences
  getPreferences: () => api.get('/auth/preferences'),
  
  // Update user preferences
  updatePreferences: (preferences: {
    preferredApplication?: string;
    theme?: string;
    language?: string;
    [key: string]: any;
  }) => api.put('/auth/preferences', { preferences }),
};

export default api;
